import { removeToast } from "../../utils";
import { allToastMessages } from "../data";
async function submitForm(
  data,
  setToastMsg,
  setDisableSubmit,
  setThankYouScreen
) {
  const res = await fetch(`/api/pushEntrepriseSignup`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });
  const response = await res.json();
  if (response.success) {
    removeToast(setToastMsg);
    setDisableSubmit(true);
    setThankYouScreen(true);
  } else {
    setToastMsg(allToastMessages.enterprise.error);
    removeToast(setToastMsg);
  }
}

export default async function submitEnterprise(
  form,
  setToastMsg,
  setDisableSubmit,
  setThankYouScreen,
  details
) {
  const userDetails = {
    name: form.name.value,
    emailId: form.email.value,
    companySize: form.company.value,
    countryCode: details.dialCode,
    phone: details.phone,
    country: details.countryCode,
    brandId: process.env.BRAND_ID,
    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  };

  const data = {
    type: "enterprise",
    ...userDetails,
  };

  setToastMsg(allToastMessages.enterprise.availability);
  await submitForm(data, setToastMsg, setDisableSubmit, setThankYouScreen);
}
